export { SafeAreaProvider, SafeAreaView, useSafeAreaInsets } from "react-native-safe-area-context";
